require('./platform-offer-card.scss');

riot.tag2('platform-offer-card', '<div class="offer-card-container"> <h3 class="offer-card-type acr-secondary-title-5"> {opts.type} </h3> <div class="offer-card-content"> <p class="offer-card-expiration acr-paragraph-5" if="{opts.expiration}"> {opts.expiration} </p> <p class="offer-card-title acr-label-3">{opts.title}</p> <p class="offer-card-payment"> <offer-raw-html class="acr-caption-2" content="{opts.payment}"></offer-raw-html> </p> <p class="offer-card-term"> <offer-raw-html class="acr-paragraph-7" content="{opts.term}"></offer-raw-html> </p> <p class="offer-card-legal"> <offer-raw-html class="acr-paragraph-11" content="{opts.legal}"></offer-raw-html> </p> <div class="offer-card-cta-container"> <div class="offer-card-button-container" if="{opts.buttonText}"> <button class="offer-card-button acr-cta-btn is-dark" data-automation="{opts.offerId+\'_\'+opts.buttonText.toLowerCase().replaceAll(\' \',\'-\')}" onclick="{onButtonClick}">{opts.buttonText}</button> </div> <div class="offer-card-link-container"> <a class="offer-card-link acr-cta-text" href="" data-automation="{opts.offerId+\'_\'+opts.linkText.toLowerCase().replaceAll(\' \',\'-\')}" onclick="{onLinkClick}">{opts.linkText}</a> </div> </div> </div> </div>', '', '', function(opts) {
    window.Acr = window.Acr ? window.Acr : {};
    const self = this;
    self.mixin('bus');

    self.onButtonClick = (e) => {
      const cookieZipcode = localStorage.getItem('userZipCode');

      if (cookieZipcode) {
        self.bus.trigger(self.bus.EVENTS.OFFER_CARD.BUTTON_CLICK, {
          event: e,
          id: self.opts.id,
        });
      } else {
        Acr.zipgateComponent.openZipgate(self.onButtonClick, e);
      }
    };

    function getMonthsBetween(start, end) {
      const startSplitted = start.split('-');
      const endSplitted = end.split('-');
      for (let i = 0; i < startSplitted.length; i++) startSplitted[i] = parseInt(startSplitted[i], 10);
      for (let i = 0; i < endSplitted.length; i++) endSplitted[i] = parseInt(endSplitted[i], 10);
      const date1 = new Date(startSplitted[0], startSplitted[1], startSplitted[2]);
      const date2 = new Date(endSplitted[0], endSplitted[1], endSplitted[2]);
      const year1 = date1.getFullYear();
      const year2 = date2.getFullYear();
      let month1 = date1.getMonth();
      let month2 = date2.getMonth();
      let result = 0;
      if (month1 === 0) {
        month1++;
        month2++;
      }
      result = ((year2 - year1) * 12) + (month2 - month1) + 1;
      return `${result.toString()} months`;
    }

    function getOfferTerm(data) {
      let term = '';
      if (data.LeasePaymentInfo && data.LeasePaymentInfo.TermMonths) {
        term = `${data.LeasePaymentInfo.TermMonths.toString()} months`;
      } else if (data.PaymentTerms && data.PaymentTerms.FinanceTerms) {
        term = [];
        data.PaymentTerms.FinanceTerms.forEach((element) => {
          const termItem = `${element.TermMin} months - ${element.TermMax} months`;
          term.push(termItem);
        });
        term = term.join(' | ');
      }
      return term;
    }

    function getTrackingData(isOpen, offer) {
      const trackingData = self.opts.trackingJson ? JSON.parse(self.opts.trackingJson) : undefined;
      if (trackingData) {
        const jsonData = JSON.parse(JSON.stringify(trackingData));
        jsonData.Offer.offer_type = offer.type;
        jsonData.Model = {
          model_name: offer.ModelGroupName,
          model_year: offer.ModelYear ? offer.ModelYear.toString() : '',
        };
        jsonData.Offer.offer_amount = offer.payment;
        jsonData.Offer.offer_name = offer.SalesProgramName;
        jsonData.Offer.offer_date = `${offer.StartDate} | ${offer.EndDate}`;
        jsonData.Offer.offer_model = offer.ModelGroupName;
        jsonData.Offer.offer_model_year = offer.ModelYear ? offer.ModelYear.toString() : '';
        jsonData.Offer.offer_duration = getMonthsBetween(offer.StartDate, offer.EndDate);
        jsonData.Offer.offer_term = getOfferTerm(offer);
        jsonData.Offer.offer_expire = offer.EndDate;
        jsonData.Offer.offer_start = offer.StartDate;
        jsonData.Offer.offer_id = offer.Id;
        if (isOpen) {
          jsonData.dynamic_variables[0].search += `${jsonData.Offer.offer_name} offer details`;
        } else {
          jsonData.dynamic_variables[0].search += `${jsonData.Offer.offer_name} hide details`;
        }
        if (window.Acr.TrackingManager) {
          window.Acr.TrackingManager.clickActivity(jsonData);
        }
      }
    }

    self.onLinkClick = (e) => {
      const isOpen = (e.currentTarget.innerText.toUpperCase() === 'OFFER DETAILS');
      getTrackingData(isOpen, e.item.offer);
      self.bus.trigger(self.bus.EVENTS.OFFER_CARD.LINK_CLICK, {
        event: e,
        id: self.opts.id,
      });
    };

});
